import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import { SavedSearchItem } from './SavedSearchItem';
import * as JobActions from '../../../../../../actions/jobs/jobs';
import * as requestHelpers from "../../../../../../helpers/requests";
import { dateHelpers } from '../../../../../../helpers';
import DeleteModal from '../../../../../common/elements/DeleteModal';

class SavedSearchInfo extends Component {

	constructor(props) {
		super(props);
		this._isMounted = false;
		this.state = {
			toggle: false,
			completeSearchDetails: null,
			modal: null
		}
	}


	componentWillMount() {
		this._isMounted = true;
		requestHelpers
			.authenticatedGetRequest(`/people/${this.props.personId}/jobs/saved-searches/${this.props.searchId}`)
			.then(response => { if(this._isMounted){ this.setState({ completeSearchDetails: response.data })}});
	}

	componentWillUnmount(){
		this._isMounted = false;
	}

	handleToggle = () => {
		const { toggle } = this.state;
		this.setState({ toggle: !toggle })
	};

	runSavedSearch = () => {
		const { keyword, updateJobOptions } = this.props,
			{ completeSearchDetails } = this.state;
		const searchItems = completeSearchDetails ? { ...completeSearchDetails } : null;

		delete searchItems.created_at;
		delete searchItems.deleted_at;
		delete searchItems.id;
		delete searchItems.name;
		delete searchItems.network;
		delete searchItems.network_id;
		delete searchItems.person_id;
		delete searchItems.keyword;

		const optionData = {};

		if (keyword) {
			optionData['keyword'] = keyword;
		}

		Object.keys(searchItems).map((searchKey) => {
			const splitKey = searchKey.split('_');
			const column = splitKey.includes('common') ? splitKey[1] : searchKey;
			const newKey = column.concat('_id');

			if (searchItems && searchItems[searchKey].length === 1) {
				optionData[newKey] = [{ value: searchItems[searchKey][0].id, label: searchItems[searchKey][0].name }];
			}
			else {
				const data = [];
				searchItems && searchItems[searchKey].length > 1 && searchItems[searchKey].map((search) => {
					data.push({ value: search.id, label: search.name });
				});

				optionData[newKey] = data;
			}
		});
		updateJobOptions(optionData);

		browserHistory.push(`/jobs`);
	};

	setAlert = flag => {

		const { searchId, personId, setAlert, index } = this.props;

		setAlert(personId, searchId, flag, index);
	};

	handleDelete = () => {
		this.props.deleteSavedSearch(this.props.personId, this.props.searchId)
		this.setState({ modal: null })
	}

	render() {
		const { index, name, createdAt, keyword } = this.props,
			{ toggle, completeSearchDetails } = this.state;


		const displaySearchItems = completeSearchDetails ? { ...completeSearchDetails } : { ...null };

		if (displaySearchItems) {
			delete displaySearchItems["network_id"];
			delete displaySearchItems["saved"];
			delete displaySearchItems["alert"];
			delete displaySearchItems["created_at"];
			delete displaySearchItems["deleted_at"];
			delete displaySearchItems["person_id"];
			delete displaySearchItems["id"];
			delete displaySearchItems["name"];
			delete displaySearchItems["keyword"];
		}


		const _toggle = toggle ? "item-uncollapsed" : "item-collapsed";
		let seeMoreInfoClassnames = completeSearchDetails ? "btn btn-primary--ghost small" : "btn btn-primary--ghost small disabled";
		let showCorrectButton = completeSearchDetails ? (
			<div className="col-sm-3 col-lg-2 col--run-search">
				<button onClick={() => this.runSavedSearch()}
					className='theme-button'>
					Search
			</button>
			</div>) :
			<div className="col-sm-4 col-lg-2 col--run-search">
				<button onClick={() => this.runSavedSearch()}
					className='theme-button'
					disabled >
					Search
				</button>
			</div>

		return (
			<div className="manage-jobs-item">
				<div className="manage-jobs-item__summary saved-search-info">
					<div className="row">
						<div className="col-xs-12 col-lg-3 col--name">
							<span className="main__name">{name ? name : 'Unnamed Search'}</span>
						</div>
						<div className="col-xs-12 col-lg-2 col--date">
							<span className="visible-xs-inline-block">Date created: </span>
							<span className="main__date">{dateHelpers.dateConverter(createdAt)}</span>
						</div>

						{showCorrectButton}

						<div className="col-xs-7 col-sm-3 col-lg-3 col--more-info">
							<button className={seeMoreInfoClassnames}
								onClick={() => this.handleToggle()}
								data-target={'#saved-search-item-' + index}>
								{completeSearchDetails ? <span className="label">See more info</span> : <span className="label">Loading search info</span>}
								<span className="icon"><i className={`fa ${toggle ? "fa-angle-up" : "fa-angle-down"}`} /></span>
							</button>
						</div>
						<div className="col-xs-5 col-sm-5 col-lg-1 col--remove">
							<button onClick={() => this.setState({ modal: 'yes' })}
								className="btn btn-warning small btn-rmv">

								<span className="label mob-txt">Remove</span>
								<span className="icon saved-search "><i className="fa fa-times" /></span>
							</button>
						</div>
						<div>
							{this.state.modal &&
								<DeleteModal header='Are you sure?' message="This can't be undone." onClose={() => this.setState({ modal: null })} onDelete={this.handleDelete} />}
						</div>
					</div>
				</div>

				{displaySearchItems !== undefined ?
					<div className={`manage-jobs-item__details ${_toggle}`}
						id={'saved-search-item-' + index}>
						<div className="details__body">
							<div className="row">

								<div className="col-xs-12">
									<div className="details__keyword">
										<h6 className="h6 details__header">Keyword</h6>
										<div className="details__value">{keyword ? keyword : "-"}</div>
									</div>
								</div>

								{
									Object.keys(displaySearchItems).map((searchKey, index) => {
										const splitKey = searchKey.split('_');

										const column = splitKey.includes('common') ? splitKey[1] : splitKey.join(' ');
										if (displaySearchItems[searchKey].length > 0) {
											return (
												<div key={index} className="col-xs-12 col-sm-6 col-lg-4 col-lg-2 details__info">
													<h6 className="h6 details__header">{column}</h6>
													<SavedSearchItem data={displaySearchItems[searchKey]} index={index} />
												</div>
											)
										} else {
											return (
												<div key={index} className="col-xs-12 col-sm-6 col-lg-4 col-lg-2 details__info">
													<h6 className="h6 details__header">{column}</h6>
													<div className="details__value">-</div>
												</div>
											)
										}

									})
								}
							</div>
						</div>
					</div> : <div>Loading</div>
				}
			</div>
		)
	}
}

SavedSearchInfo.contextTypes =
	{ router: PropTypes.object.isRequired };

const mapStateToProps = (state) => {
	return {
		savedSearch: state.jobs.savedSearch,
		isFetching: state.jobs.isSavedSearchFetching,
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateJobOptions: (options) => dispatch(JobActions.updateJobOptions(options)),
		setAlert: (personId, searchId, flag, index) => dispatch(JobActions.setAlert(personId, searchId, flag, index)),
	}
};

	export default connect(mapStateToProps, mapDispatchToProps)(SavedSearchInfo);



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/SavedSearchInfo.js